import React from 'react';
import moment from 'moment';
import PropTypes from 'prop-types';

import ErrorMessageElementImg from 'assets/img/ErrorMessageElement.png';
import ErrorMessageGeneralImg from 'assets/img/ErrorMessageGeneral.png';

import './scss/errorMessages.scss';

class ErrorMessage extends React.Component {
  handleMarkForRetry = () => {
    const { call, elementId, tick } = this.props;

    call(`MarkForRetry/${elementId}`);
    tick();
  }

  render() {
    const {
      elementType,
      errorIsNew,
      errorStamp,
      onTryAgain,
      recordName,
      syncError,
      text,
    } = this.props;

    let recordLabel = '';
    let className = 'all';
    let imageSrc = '';

    if (recordName) {
      recordLabel = <span>{ moment(errorStamp).format('MM/DD/YYYY h:mm:ss a') } ({ recordName }): </span>;
      className += ' element';
      imageSrc = ErrorMessageElementImg;

      if (errorIsNew) {
        className += ' elementNew';
      }
    } else {
      className += ' general';
      imageSrc = ErrorMessageGeneralImg;
    }

    if (syncError) {
      return (
        <div className={ className }>
          <div>
            <img alt="" src={ imageSrc } />

            { !recordName && <a onClick={ onTryAgain }>Try again</a> }

            <span>{ recordLabel }{ text }</span>
          </div>
        </div>
      );
    }

    return (
      <tr>
        <td className="tableCellMiddle">{ moment(errorStamp).format('lll') }</td>
        <td className="tableCellMiddle">{ elementType }</td>
        <td className="tableCellMiddle">{ recordName }</td>
        <td>{ text }</td>
        <td>
          <div className="retry" onClick={ this.handleMarkForRetry } />
        </td>
      </tr>
    );
  }
}

ErrorMessage.defaultProps = {
  elementId: 0,
  elementType: '',
  errorIsNew: false,
  errorStamp: '',
  onTryAgain: null,
  recordName: null,
  syncError: '',
};

ErrorMessage.propTypes = {
  elementId: PropTypes.number,
  elementType: PropTypes.string,
  errorIsNew: PropTypes.bool,
  errorStamp: PropTypes.string,
  recordName: PropTypes.string,
  syncError: PropTypes.string,
  text: PropTypes.string.isRequired,

  // functions
  call: PropTypes.func.isRequired,
  onTryAgain: PropTypes.func,
  tick: PropTypes.func.isRequired,
};

export default ErrorMessage;



// WEBPACK FOOTER //
// ./src/components/Status/components/SyncPanel/components/ErrorMessage.js